import React from "react";
import PropTypes from "prop-types";

import Breadcrumbs from "../../components/BreadCrumbs";

const ClientPortalPage = ({ title }) => (
  <div className="client-portal-page">
    <div className="page-title-margin">
      <Breadcrumbs
        list={[
          {
            path: "",
            label: title,
          },
        ]}
        BreadCrumbHasBackIcon={false}
      />
      <h1>{title}</h1>
    </div>
  </div>
);

ClientPortalPage.propTypes = {
  title: PropTypes.string.isRequired,
};

export default ClientPortalPage;
